$(document).ready(function() {
  var getAllSwatchGrades = '';
$('.order-free-swatch-popup-right .pdp-variant-list-head').each(function() {
  getAllSwatchGrades = getAllSwatchGrades + ',' + $(this).text().trim();
});
  console.log('my get all swatch grades is ' + getAllSwatchGrades);
  $('.grade-swatch').each(function() {
    var grade = $(this).data('grade');
    if (getAllSwatchGrades.indexOf(grade) === -1) {
      $(this).hide();
    }
  });
    const svgMarkup = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: middle; margin-right: 8px;">
      <path d="M20.1253 6.9375H18.5625V3.75C18.5625 3.60082 18.5032 3.45774 18.3977 3.35225C18.2923 3.24676 18.1492 3.1875 18 3.1875H6C5.85082 3.1875 5.70774 3.24676 5.60225 3.35225C5.49676 3.45774 5.4375 3.60082 5.4375 3.75V6.9375H3.87469C2.66906 6.9375 1.6875 7.86281 1.6875 9V16.5C1.6875 16.6492 1.74676 16.7923 1.85225 16.8977C1.95774 17.0032 2.10082 17.0625 2.25 17.0625H5.4375V20.25C5.4375 20.3992 5.49676 20.5423 5.60225 20.6477C5.70774 20.7532 5.85082 20.8125 6 20.8125H18C18.1492 20.8125 18.2923 20.7532 18.3977 20.6477C18.5032 20.5423 18.5625 20.3992 18.5625 20.25V17.0625H21.75C21.8992 17.0625 22.0423 17.0032 22.1477 16.8977C22.2532 16.7923 22.3125 16.6492 22.3125 16.5V9C22.3125 7.86281 21.3309 6.9375 20.1253 6.9375ZM6.5625 4.3125H17.4375V6.9375H6.5625V4.3125ZM17.4375 19.6875H6.5625V14.8125H17.4375V19.6875ZM21.1875 15.9375H18.5625V14.25C18.5625 14.1008 18.5032 13.9577 18.3977 13.8523C18.2923 13.7468 18.1492 13.6875 18 13.6875H6C5.85082 13.6875 5.70774 13.7468 5.60225 13.8523C5.49676 13.9577 5.4375 14.1008 5.4375 14.25V15.9375H2.8125V9C2.8125 8.48344 3.28875 8.0625 3.87469 8.0625H20.1253C20.7113 8.0625 21.1875 8.48344 21.1875 9V15.9375ZM18.5625 10.875C18.5625 11.0604 18.5075 11.2417 18.4045 11.3958C18.3015 11.55 18.1551 11.6702 17.9838 11.7411C17.8125 11.8121 17.624 11.8307 17.4421 11.7945C17.2602 11.7583 17.0932 11.669 16.9621 11.5379C16.831 11.4068 16.7417 11.2398 16.7055 11.0579C16.6693 10.876 16.6879 10.6875 16.7589 10.5162C16.8298 10.3449 16.95 10.1985 17.1042 10.0955C17.2583 9.99248 17.4396 9.9375 17.625 9.9375C17.8736 9.9375 18.1121 10.0363 18.2879 10.2121C18.4637 10.3879 18.5625 10.6264 18.5625 10.875Z" fill="black"></path>
    </svg>
  `;

  const interval = setInterval(() => {
    const btn = document.getElementById('myBtn-litpdf');
    if (btn && !btn.querySelector('svg')) {
      // Clear once the element is found
      clearInterval(interval);
      
      // Add icon + text
      btn.innerHTML = svgMarkup + 'Print as PDF';
    }
  }, 100);
      const modal = document.getElementById('myModal-litpdf');
    const modalContent = modal.querySelector('.modal-content-litpdf');

    modal.addEventListener('click', function (e) {
      // If the click target is the modal itself and NOT a child of modal-content
      if (e.target === modal) {
        modal.removeAttribute('style'); // Remove inline style (hides the modal)
      }
    });
  $('body').on('click','.dekstech-custom-select .options-selection__option-value',function() {
    var value = $(this).find('input').attr('value');
    console.log('my clicked value is ' + value);
    $('.dekstech-theme-options input').each(function() {
      var inputVal = $(this).attr('value');
      console.log('my input value is ' + inputVal);
      if (value === inputVal) {
        console.log('we match and trying to click');
        $(this).parent().trigger('click');
      }
    });
  });
  
  
window.ChatNow = function () {
  let tries = 0;

  function openWhenReady() {
    if (typeof Chatra === 'function') {
      Chatra('openChat', true);
    } else if (tries < 10) {
      tries++;
      setTimeout(openWhenReady, 300); // Retry every 300ms
    } else {
      console.warn('Chatra still not loaded after 10 tries.');
    }
  }

  openWhenReady();
};

    function updatePlusBtnText() {
      $('.pdp-sixtin-plus-var-li').each(function() {
        const totalSwatches = $(this).text().replace('+', '');
        const visibleSwatches = $(this).siblings(':not(.pdp-sixtin-plus-var-li)').length;
        console.log("totalSwatches, visibleSwatches",totalSwatches, visibleSwatches);
        // Calculate remaining swatches
        
        // For mobile, subtract 2 more from the count
        const isMobile = window.innerWidth <= 767;
        if (isMobile) {
           let remainingSwatches = parseInt(totalSwatches) + 2;
          const $button = $('.pdp-sixtin-plus-var');

           $button.text('+' + remainingSwatches);
        }
        
        // Update the text
       
      });
    }
    
    // Run on page load and window resize
    updatePlusBtnText();
    // when a swatch is clicked, we highlight it
     $('.pdp-variant-list li').click(function () {
      if ($(this).hasClass('pdp-sixtin-plus-var-li')) {
        // Just show the popup and exit
        $('body').addClass('order-swatch-popup-body');
        return;
      }

      $(this).siblings().removeClass('active');
      // Make this list item active within its own section
      $('.order-swatch-popup-right .pdp-variant-list li').each(function() {
        if(!$(this).hasClass('finish-details') && !$(this).hasClass('trim-details')) {
          $(this).removeClass('active');
        }
        
        
      });
     
      $(this).addClass('active');
      
      // Get the image inside this list item
      var $img = $(this).find('.swatch-before-arrow img');
      
      // Get leather name data
      var swatchValue = $img.data('leather-name');
      
      // We no longer sync with popup swatches to keep them separate
      // $('.order-swatch-popup-right li').removeClass('active');
      // $('.order-swatch-popup-right li[data-leather-name="' + swatchValue + '"]').addClass('active');
      
      var Grade = $img.data('leather-grade').trim();
      var LeatherName = $img.data('leather-name').trim();

      
      // Update options selection
      if (Grade && Grade.trim() !== 'No Grade') {
      var foundGrade = false;
      $('.options-selection__option-values span').each(function () {
        if ($(this).text().trim() === Grade) {
          $(this).trigger('click');
          $('#selected-leather').val(LeatherName);
          $('#selected-leather').attr('value', LeatherName);
          foundGrade = true;
        }
      });
      if (foundGrade === false) {
        // we need to change all the buttons because the pricing will not be shown on website, they need to call
        $('.save-swatches-btn').text('Call For Pricing');
        $('#popup-footer-price').hide();
        $('.call_price').removeAttr('style');
        $('.product-form--atc-button').find('.atc-button--text').text('Call For Pricing');
        $('.product-pricing').find('.product__price').addClass('hide-price');
      }
       else {
                 $('.save-swatches-btn').text('Order Now');
         $('.call_price').hide();
        $('#popup-footer-price').show();
        $('.product-form--atc-button').find('.atc-button--text').text('Add to Cart');
         $('.product-pricing').find('.product__price').removeClass('hide-price')
       }
      }
      var product_tags = $('#product-tags').attr('value')
      
      // Handle special cases
      if ($img.hasClass('finish')) {
        if (product_tags.indexOf('no-wood') > -1) {

        }
       else {
          $('#wood-finish').val(LeatherName);
          $('#wood-finish').attr('value', LeatherName);
          $('#finish-name-wrapper span').text(LeatherName);
      }
      }
      else if ($img.hasClass('trim')) {
        
        
        if (product_tags.indexOf('no-nail') > -1) {

        }
         
        else {
          $('#nail-trim').val(LeatherName);
         $('#nail-trim').attr('value', LeatherName);
          $('#trim-name-wrapper span').text(LeatherName);
      }
      }
        else {
        $('#leather-popup-name').text(LeatherName);
        $('#leather-name-wrapper span').text(LeatherName);
      }
    });
    
    // When a swatch is clicked in the popup
    $('.order-swatch-popup-right li').click(function() {
      
      // Make this popup swatch active
      $(this).siblings().removeClass('active');
      $(this).addClass('active');
      // ✅ Only apply on mobile
if (window.innerWidth <= 768) {
  const popup = $(this).find('.pdp-variant-popup-section');
  if (popup.length) {
    console.log('found and trying to replace');

    const img = popup.find('.pdp-variant-popup-left').html();
    const textSection = popup.find('.pdp-variant-popup-right').clone();

    // ✅ Move .protected-desc to top
    const protectedDesc = textSection.find('.protected-desc');
    if (protectedDesc.length) {
      protectedDesc.prependTo(textSection); // moves it to be the first child
    }

    const updatedText = textSection.html();

    $('.image-holder, .content-holder').stop(true, true).fadeOut(150, function () {
      if ($(this).hasClass('image-holder')) {
        $(this).html(img);
      } else {
        $(this).html(updatedText);
      }
    }).fadeIn(150);
  } else {
    console.log('not found');
  }
}
  // lets get the active swatch
           if ($(this).hasClass('free-swatch')) {
return
           }
      else {
             
      var selectedSwatch = $('.order-swatch-popup-section').find('.pdp-variant-list li.active');
      var activeImg = $('.order-swatch-popup-section').find('.pdp-variant-list li.active').find('img').attr('src');
      var popupHTML = selectedSwatch.find('.pdp-variant-popup-section').html();
      $('.variant-details.active').removeClass('active');
      var foundSwatch = 0;
      $('.variant-details').each(function() {
        var leather = $(this).data('leather-name');
        if (selectedSwatch.data('leather-name') === leather) {
          $(this).addClass('active');
          foundSwatch = 1;
        }
      });
      if (foundSwatch === 0) {
        $('.variant-details').eq(0).addClass('active');
      }
                $('.variant-details.active').find('img').attr('src',activeImg);
        $('.variant-details.active').attr('data-leather-name', selectedSwatch.data('leather-name'));
        $('.variant-details.active').find('.pdp-variant-popup-section').html(popupHTML);
        $('#leather-name-wrapper').find('span').text( selectedSwatch.data('leather-name'));
        console.log($('#leather-popup-name').length);
        $('#leather-popup-name').empty().text(selectedSwatch.data('leather-name'));
      }
    });
    

    $('.american-heirloom-popup-part').on('click', function(e){
      // Remove active class from siblings to ensure only one is active at a time
      $(this).siblings('.american-heirloom-popup-part').removeClass('active');
      $(this).addClass('active');
      $('#cushion-option').val($(this).data('cushion-option'));
    });
$('body').on('click', '.product-form--atc-button', function (e) {
  e.preventDefault(); // Stop form submission early
  e.stopImmediatePropagation();
  const btnText = $(this).find('.atc-button--text').text().trim();
  const form = $(this).closest('form');
  const formDataArray = form.serializeArray(); // Used by AddToCartFlyout

  // Handle "Call For Pricing"
  if (btnText === 'Call For Pricing' || btnText === 'Calling For Pricing') {
    const link = document.querySelector('.call_price a');
    if (link) link.click();
    return;
  }

  // Cushion check
  const cushionVisible = $('.cushion-pdp-desc').css('display') === 'block';
  const cushionSelected = $('.american-heirloom-popup-part.active').length > 0;

  if (cushionVisible && !cushionSelected) {
    alert('You must pick a cushion before adding this product to cart');
    $('body').addClass('american-heirloom-popup-body');
    return;
  }

  // ✅ All validation passed — now instantiate AddToCartFlyout
  new AddToCartFlyout(formDataArray, {
    atcButton: this,
    settings: {
      moneyFormat: Shopify.money_format,
      cartRedirection: false // Or true if needed
    }
  });
});


  
});